import React from 'react';
import Button from '@mui/material/Button';
import '../style/Components.css';

interface OutlinedButtonProps {
  onClick: () => void;
  text: string;
  icon?: React.ReactNode; // 傳入的圖示
}

const OutlinedButton: React.FC<OutlinedButtonProps> = ({ onClick, text, icon }) => {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      className='outlined-button'
    >
      {icon}{text}
    </Button>
  );
};

export default OutlinedButton;
